import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';

import { InitStepDesktop as InitStep } from '../view/init/desktop';
import { EsiaDataAdditionStepDesktop as EsiaDataAdditionStep } from '../view/esia-data-addition/desktop';
import { DocumentsSignInformationStepDesktop as DocumentsSignInformationStep } from '../view/documents-sign-information/desktop';
import { DocumentsSignInformationClientStepDesktop as DocumentsSignInformationClientStep } from '../view/documents-sign-information-client/desktop';
import { ChangingAddressDesktop as ChangingAddress } from '../view/changing-address/desktop';
import { SmsVerificationDesktop as SmsVerification } from '../view/sms-verification/desktop';
import { DocumentSignSmsVerificationDesktop as DocumentSignSmsVerification } from '../view/sms-document-sign/desktop';
import { ErrorDesktop as Error } from '../view/error/desktop';
import { Component } from '../layout/desktop';
import type { TInvestSmevDesktop, IDepsDesktop } from '../models';

export const InvestFormSMEVDesktop = createWidget<IDepsDesktop, TInvestSmevDesktop>({
    Block,
    ChangingAddress,
    DocumentsSignInformationStep,
    DocumentsSignInformationClientStep,
    DocumentSignSmsVerification,
    InitStep,
    EsiaDataAdditionStep,
    SmsVerification,
    Error,
})(Component);
